export { Media, MontanaMediaRatios } from './media.component';
